import { json } from 'd3';
import { makeUrl } from './etc/apiHelpers';
import { URLHandler } from './etc/URLHandler';
import { memoize } from "./etc/cacher";
const baseurl = URLHandler.basicURL();
const backendURL = baseurl + "/api";
function sentenceToKeywords(sentence) {
    const route = "/sentence-to-keywords";
    let toSend = { sentence };
    const url = makeUrl(backendURL + route, toSend);
    console.log("--- GET " + url);
    return json(url);
}
function getNNeurons() {
    const route = "/n-heads";
    const url = makeUrl(backendURL + route, {});
    console.log("--- GET " + url);
    return json(url);
}
function getNeuronConcepts(neuron_idx, n_show = 20) {
    const route = "/memory-concepts";
    let toSend = { head_index: neuron_idx, n_show };
    const url = makeUrl(backendURL + route, toSend);
    console.log("--- GET " + url);
    return json(url);
}
function getNeuronOrdering() {
    const route = "/mem-order";
    const url = makeUrl(backendURL + route, {});
    console.log("--- GET " + url);
    return json(url);
}
function queryTopNeuronsByPhrase(phrase, beta = 10.0) {
    const route = "/query-top-mems-by-phrase";
    let toSend = { phrase, beta };
    const url = makeUrl(backendURL + route, toSend);
    console.log("--- GET " + url);
    return json(url);
}
export const api = {
    findResponseJson: (s) => "Using live API, no JSON",
    sentenceToKeywords: memoize(sentenceToKeywords),
    getNNeurons: memoize(getNNeurons),
    getNeuronConcepts: memoize(getNeuronConcepts),
    getNeuronOrdering: memoize(getNeuronOrdering),
    queryTopNeuronsByPhrase: memoize(queryTopNeuronsByPhrase)
};
